import { strings } from '@/strings';

export function UnauthorizedPage() {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <h1 className="text-xl font-bold text-primary">{strings.unauthorizedTitle}</h1>
    </main>
  );
}
